import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Building2, Target, Users, Award } from "lucide-react";
const SobrePage = () => {
  return <div className="min-h-screen flex flex-col bg-background">
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/10 via-background to-accent/10 py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">Sobre a <span className="text-accent">JobWay</span><span className="text-primary">X</span></h1>
              <p className="text-lg text-muted-foreground">Conectando talentos e oportunidades em todo o Brasil</p>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="mobile-container md:w-full grid md:grid-cols-2 gap-12 items-center max-w-6xl md:mx-auto">
              <div>
                <h2 className="text-3xl font-bold mb-6 text-foreground">Nossa Missão</h2>
                <p className="text-muted-foreground mb-4">A JobWayX nasceu com o propósito de facilitar a conexão entre candidatos em busca de novas oportunidades e empresas que desejam contratar os melhores profissionais da região.</p>
                <p className="text-muted-foreground">
                  Acreditamos que o processo de recrutamento deve ser simples, rápido e eficiente para ambos os lados,
                  por isso desenvolvemos uma plataforma intuitiva que atende tanto candidatos quanto empresas.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-card p-6 rounded-lg border border-border text-center">
                  <Users className="w-12 h-12 text-primary mx-auto mb-3" />
                  <h3 className="font-semibold text-2xl mb-1 text-foreground">10k+</h3>
                  <p className="text-sm text-muted-foreground">Candidatos</p>
                </div>
                <div className="bg-card p-6 rounded-lg border border-border text-center">
                  <Building2 className="w-12 h-12 text-accent mx-auto mb-3" />
                  <h3 className="font-semibold text-2xl mb-1 text-foreground">500+</h3>
                  <p className="text-sm text-muted-foreground">Empresas</p>
                </div>
                <div className="bg-card p-6 rounded-lg border border-border text-center">
                  <Target className="w-12 h-12 text-primary mx-auto mb-3" />
                  <h3 className="font-semibold text-2xl mb-1 text-foreground">2k+</h3>
                  <p className="text-sm text-muted-foreground">Vagas Ativas</p>
                </div>
                <div className="bg-card p-6 rounded-lg border border-border text-center">
                  <Award className="w-12 h-12 text-accent mx-auto mb-3" />
                  <h3 className="font-semibold text-2xl mb-1 text-foreground">95%</h3>
                  <p className="text-sm text-muted-foreground">Satisfação</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-16 bg-muted/30">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-3xl font-bold mb-12 text-center text-foreground">Nossos Valores</h2>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Target className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2 text-foreground">Simplicidade</h3>
                  <p className="text-sm text-muted-foreground">
                    Processos descomplicados para facilitar sua experiência
                  </p>
                </div>
                <div className="text-center">
                  <div className="bg-accent/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Users className="w-8 h-8 text-accent" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2 text-foreground">Conexão</h3>
                  <p className="text-sm text-muted-foreground">Unindo pessoas e oportunidades de forma eficiente</p>
                </div>
                <div className="text-center">
                  <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Award className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2 text-foreground">Qualidade</h3>
                  <p className="text-sm text-muted-foreground">Compromisso com a excelência em cada detalhe</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-bold mb-4 text-foreground">Quer saber mais?</h2>
              <p className="text-muted-foreground mb-8">
                Entre em contato conosco e descubra como podemos ajudar você ou sua empresa
              </p>
              <a href="/contato" className="inline-flex items-center justify-center rounded-md bg-primary px-8 py-3 text-sm font-medium text-primary-foreground shadow hover:bg-primary/90 transition-colors">
                Fale Conosco
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>;
};
export default SobrePage;